import React from "react";

export default function Shared() {
  return (
    <>
      {/* <Box sx={{display:"flex"}}>
        <Sidenav/> */}

      <section className="mb-3">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Shared</h5>
            <p className="card-text">
              With supporting text below as a natural lead-in to additional content.
            </p>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" className="btn btn-primary">
              Go somewhere
            </a>
          </div>
        </div>
      </section>
      {/* </Box> */}
    </>
  );
}
